import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {DungeonQuestHelper} from "../../bigSymbols/DungeonQuestHelper";
import {DungeonQuest} from "../../DungeonQuest";
import {DungeonQuestGameAssets} from "../../DungeonQuestGameAssets";


/**
 * Created by Jonas Wålekvist on 2018-06-27.
 */

export class FreeSpinIntroSymbol extends PIXI.Container {
    private _lowSymbol:PIXI.Sprite;
    private _lowWhite:PIXI.Sprite;
    private _wildTransform:TimelineSprite;
    private _lowHighLight:PIXI.Sprite;
    private _symbolContainer:PIXI.Container;
    public color:number;


    constructor(lowSymbol:string) {
        super();

        this.color = DungeonQuestHelper.getSymbolColor(lowSymbol);
        const lowTexture:PIXI.Texture = DungeonQuestGameAssets.getSymbolStateTextures(lowSymbol)[0];
        const wildTransformTextures:PIXI.Texture[] = GameResources.getTextures(DungeonQuestGameAssets.WILD_STICKY_SYMBOL_TRANSFORM);


        this._lowSymbol = new PIXI.Sprite(lowTexture);
        this._lowSymbol.anchor.set(0.5, 0.5);

        this._lowWhite = new PIXI.Sprite(DungeonQuest.colorEffectTextureCache.getWhiteTexture(lowTexture));
        this._lowWhite.blendMode = PIXI.BLEND_MODES.ADD;
        this._lowWhite.anchor.set(0.5, 0.5);

        this._lowHighLight = new PIXI.Sprite(DungeonQuest.colorEffectTextureCache.getDesaturatedTexture(lowTexture, 0.5));
        this._lowHighLight.anchor.set(0.5, 0.5);
        this._lowHighLight.blendMode = PIXI.BLEND_MODES.ADD;


        this._wildTransform = new TimelineSprite(wildTransformTextures);
        this._wildTransform.anchor.set(0.5, 0.5);


        this._symbolContainer = new PIXI.Container();
        this._symbolContainer.addChild(this._lowSymbol);
        this._symbolContainer.addChild(this._lowHighLight);
        this._symbolContainer.addChild(this._lowWhite);

        this.addChild(this._wildTransform);
        this.addChild(this._symbolContainer);
        this.setUpForUpdate();

    }


    public setUpForIntro() {
        this._lowWhite.alpha = 1;
        this._lowHighLight.alpha = 0;
        this._wildTransform.hide();
        this._symbolContainer.scale.set(1, 1);
    }

    public setUpForUpdate() {
        this._lowWhite.alpha = 0;
        this._lowWhite.tint = 0xffffff;
        this._lowWhite.blendMode = PIXI.BLEND_MODES.ADD;
        this._lowHighLight.alpha = 0;
        this._wildTransform.hide();
        this._symbolContainer.scale.set(1, 1);
    }

    public setToEndState() {
        this._wildTransform.hide();
        this._wildTransform.setFrame(this._wildTransform.totalFrames);
        this._symbolContainer.scale.set(0, 0);
    }

    public getFromWhiteAnimation(duration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add(() => this.setUpForIntro());
        tl.add([
            new TweenLite(this._lowWhite, duration, {alpha : 0, ease : Linear.easeNone})
        ]);

        return tl;
    }

    public getAttention(duration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const customEase = CustomEase.create("custom", "M0,0 C0.046,0.61 0.16,1.199 0.382,1.2 0.506,1.2 0.506,1.046 0.654,1.018 0.748,1 0.841,1 1,1");
        tl.add(() => this.setUpForUpdate());
        tl.add([
            new TweenLite(this._lowHighLight, duration, {alpha : 0.5, ease : customEase}),
            new TweenLite(this._symbolContainer.scale, duration, {x : 1.2, y : 1.2, ease : customEase})
        ]);
        return tl;
    }

    public getToWhiteAnimation(duration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add([
            new TweenLite(this._lowWhite, duration, {alpha : 1, ease : Linear.easeNone}),
            new TweenLite(this._symbolContainer.scale, duration, {x : 0, y : 0, ease : Linear.easeNone})
        ]);

        return tl;
    }

    public getDarkenAnimation(duration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => this.setupForDarken(DungeonQuestHelper.getDarkenColor()));
        tl.add([
            new TweenLite(this._lowWhite, duration, {alpha : 0.5, ease : Linear.easeNone})
            // new TweenLite(this._symbolContainer.scale, duration, {x : 0.8, y : 0.8, ease : Linear.easeNone})
        ]);

        return tl;
    }

    private setupForDarken(color:number) {
        this._lowWhite.alpha = 0;
        this._lowWhite.tint = color;
        this._lowWhite.blendMode = PIXI.BLEND_MODES.NORMAL;
    }

    public resetDarken() {
        this._lowWhite.alpha = 0;
        this._lowWhite.tint = 0xffffff;
        this._lowWhite.blendMode = PIXI.BLEND_MODES.ADD;
        this._symbolContainer.scale.set(1);
    }

    public getTransform():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(this._wildTransform.getAnimationAutoShowHide(true, true));
        return tl;
    }


}